const findUneditedInitialTrsx = (initialTrsxFiles, activeTrsxLabel, currentLabels) => {
    const uneditedInitialTrsx = initialTrsxFiles.find((file) => file.label !== activeTrsxLabel && !currentLabels.has(file.label));
    if (uneditedInitialTrsx !== undefined) {
        return { file: uneditedInitialTrsx, variant: 'initialTrsx' };
    }
    return null;
};
const findSecondaryCurrentTrsx = (currentTrsxFiles, activeTrsxLabel) => {
    const secondaryCurrentTrsx = currentTrsxFiles.find((file) => file.label !== activeTrsxLabel);
    if (secondaryCurrentTrsx !== undefined) {
        return { file: secondaryCurrentTrsx, variant: 'currentTrsx' };
    }
    return null;
};
const findSecondaryInitialTrsx = (initialTrsxFiles, activeTrsxLabel) => {
    const secondaryInitialTrsx = initialTrsxFiles.find((file) => file.label !== activeTrsxLabel);
    if (secondaryInitialTrsx !== undefined) {
        return { file: secondaryInitialTrsx, variant: 'initialTrsx' };
    }
    return null;
};
export const resolveSecondaryTrsxFile = (projectFiles, activeTrsxLabel) => {
    var _a, _b;
    if (activeTrsxLabel === '') {
        return null;
    }
    const currentTrsxFiles = (_a = projectFiles === null || projectFiles === void 0 ? void 0 : projectFiles.files.currentTrsx) !== null && _a !== void 0 ? _a : [];
    const initialTrsxFiles = (_b = projectFiles === null || projectFiles === void 0 ? void 0 : projectFiles.files.initialTrsx) !== null && _b !== void 0 ? _b : [];
    const currentLabels = new Set(currentTrsxFiles.map((file) => file.label));
    // NOTE Priority 1: Find an initialTrsx that has no corresponding currentTrsx (unedited original)
    // and has a different label than activeTrsxLabel
    const uneditedInitial = findUneditedInitialTrsx(initialTrsxFiles, activeTrsxLabel, currentLabels);
    if (uneditedInitial !== null) {
        return uneditedInitial;
    }
    // NOTE Priority 2: Find the first currentTrsx with a different label than activeTrsxLabel
    const secondaryCurrent = findSecondaryCurrentTrsx(currentTrsxFiles, activeTrsxLabel);
    if (secondaryCurrent !== null) {
        return secondaryCurrent;
    }
    // NOTE Priority 3: Find the first initialTrsx with a different label than activeTrsxLabel
    const secondaryInitial = findSecondaryInitialTrsx(initialTrsxFiles, activeTrsxLabel);
    if (secondaryInitial !== null) {
        return secondaryInitial;
    }
    return null;
};
export const resolveEditorMode = (secondaryTrsxFile, newTranscription, secondaryProject, showSecondaryEditor) => {
    const isDouble = secondaryTrsxFile !== null
        || newTranscription.isActive
        || secondaryProject !== null;
    return isDouble
        ? { layout: 'double', showSecondaryEditor }
        : { layout: 'single' };
};
export const resolveSecondaryTrsxToLoad = (newTranscription, secondaryTrsxFile) => {
    if (newTranscription.isActive) {
        return {
            variant: 'currentTrsx',
            fileId: newTranscription.fileId,
        };
    }
    return {
        variant: secondaryTrsxFile === null || secondaryTrsxFile === void 0 ? void 0 : secondaryTrsxFile.variant,
        fileId: secondaryTrsxFile === null || secondaryTrsxFile === void 0 ? void 0 : secondaryTrsxFile.file.id,
    };
};
